module.exports = __webpack_public_path__ + "static/media/tarta-agria-manitaria.4f5d8f49.jpg";